import { createFileRoute, redirect } from '@tanstack/react-router';
import { getAuthStore } from '../main';
import { SpSidebar } from '../components/Sidebar';
import { Pane, HStack } from '@sheridan-prize/ui';
import { MaterialSymbol, StateLayer } from '@moonjellydigital/react-components';
import { ContestList } from '../components/ContestsListsView';
import { Link } from '../components/Link';

export const Route = createFileRoute('/prize-settings')({
  beforeLoad: async () => {
    await getAuthStore().fetchUser();
    const isAuthenticated = getAuthStore().getIsAuthenticated();
    const userRole = getAuthStore().getUser()?.role;

    if (!isAuthenticated) {
      throw redirect({ to: '/login' });
    }

    if (userRole !== 'superadmin' && userRole !== 'admin') {
      throw redirect({ to: '/' });
    }

    await getAuthStore().fetchUserDoc();
  },
  component: PrizeSettings,
});

function PrizeSettings() {
  return (
    <>
      <SpSidebar />
      <Pane classes={'sp-main'} tag="main">
        <HStack gap="s4" align="center" padBlockEnd="s4">
          <h1 style={{ maxWidth: 'max-content', marginBlockStart: '0' }}>
            Prize Settings
          </h1>
          <Link
            to="/prize-settings/add"
            className={'mjd-button mjd-button_filled'}
            style={{ maxWidth: 'max-content', justifyContent: 'flex-start' }}
          >
            <StateLayer tag="span" />
            <MaterialSymbol icon="add" /> Add Prize
          </Link>
        </HStack>
        <ContestList />
      </Pane>
    </>
  );
}
